// removed by extract-text-webpack-plugin
module.exports = {"BackDrop":"Backdrop__BackDrop__3RzSK"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Backdrop/Backdrop.css
// module id = 243
// module chunks = 0